import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import { BaseCard } from '@app/components/common/BaseCard/BaseCard';
import { Row, Col } from 'antd';
import moment from 'moment';
import { Tag } from 'antd';

interface PreClearanceExtension {
  pre_clearance_id: number;
  status: 'PENDING' | 'APPROVED' | 'REJECTED';
  extension_exp: string | null;
  extension_req: string | null;
  extension_req_url?: string | null; // will be added to response later
  created_at: string;
  updated_at: string;
}

interface ExtensionInfoProps {
  extension: PreClearanceExtension;
}

const statusTagColor: Record<string, string> = {
  APPROVED: 'success',
  REJECTED: 'error',
  PENDING: 'warning',
};

const ExtensionInfo: React.FC<ExtensionInfoProps> = ({ extension }) => {
  const { pre_clearance_id, status, extension_exp, extension_req_url, created_at, updated_at } = extension;

  return (
    <BaseCard
      title={
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span>Extension Request</span>
          <Tag color={statusTagColor[status]}>{status}</Tag>
        </div>
      }
    >
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={6}>
          <div>
            <p style={{ fontSize: 12, color: 'var(--color-text-secondary)', margin: '0 0 2px' }}>Pre-clearance ID</p>
            <p style={{ fontWeight: 500, margin: 0 }}>{pre_clearance_id}</p>
          </div>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <div>
            <p style={{ fontSize: 12, color: 'var(--color-text-secondary)', margin: '0 0 2px' }}>Requested on</p>
            <p style={{ fontWeight: 500, margin: 0 }}>{moment(created_at).format('DD MMM YYYY, HH:mm')}</p>
          </div>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <div>
            <p style={{ fontSize: 12, color: 'var(--color-text-secondary)', margin: '0 0 2px' }}>Extension expiry</p>
            <p style={{ fontWeight: 500, margin: 0 }}>
              {extension_exp ? moment(extension_exp).format('DD MMM YYYY') : '—'}
            </p>
          </div>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <div>
            <p style={{ fontSize: 12, color: 'var(--color-text-secondary)', margin: '0 0 2px' }}>Last updated</p>
            <p style={{ fontWeight: 500, margin: 0 }}>{moment(updated_at).format('DD MMM YYYY, HH:mm')}</p>
          </div>
        </Col>
      </Row>

      {/* File view button — shown when URL is available */}
      {extension_req_url && (
        <div style={{ marginTop: 16, paddingTop: 16, borderTop: '0.5px solid var(--color-border-tertiary)' }}>
          <p style={{ fontSize: 12, color: 'var(--color-text-secondary)', margin: '0 0 8px' }}>Extension document</p>
          <BaseButton size="small" onClick={() => window.open(extension_req_url, '_blank')}>
            View file
          </BaseButton>
        </div>
      )}
    </BaseCard>
  );
};

export default ExtensionInfo;
